/* eslint-disable no-param-reassign */
import {
	HttpEvent,
	HttpHandler,
	HttpHeaders,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { environment } from '@environments/environment';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { v4 as uuid } from 'uuid';
import { BASE_ONBOARDING_URL } from '@shared/services/party-api/api-routes';
import { OnboardingFlowService } from '@shared/services/onboarding-flow';

const BASIC_AUTH_VALUE = btoa(
	`${environment.muleExperienceAppID}:${environment.muleExperienceAppPassword}`
);

@Injectable({
	providedIn: 'root'
})
export class RequestInterceptor implements HttpInterceptor {

	private token: string;
	private userName: string;

	constructor(
		private readonly injector: Injector,
		private onboardingFlowService: OnboardingFlowService
	) {
		this.onboardingFlowService
			.getPartiesObservable()
			.subscribe((parties) => {
				this.token = parties?.primaryIndividual?.existingCustomerLoginResponse?.accessToken ?? '';
				this.userName = parties?.business?.email ?? '';
			});
	}

	public intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		//eslint-disable-next-line no-param-reassign
		request = request.clone({
			headers: this.addHeaders(request.headers, request),
			withCredentials: true
		});

		return next.handle(request);
	}

	private addHeaders(
		headers: HttpHeaders,
		request: HttpRequest<any>
	): HttpHeaders {
		// Content Type
		if (!headers.has('Content-Type')) {
			headers = headers.append('Content-Type', 'application/json');
		}
		// Authorization
		if (!headers.has('Authorization')) {
			headers = headers.append('Authorization', `Basic ${BASIC_AUTH_VALUE}`);
		}
		// Correlation Id
		if (!headers.has('correlationId')) {
			headers = headers.append('correlationId', uuid());
		}
		// Channel
		if (
			!headers.has('channel') &&
			(!request.url.includes(`${BASE_ONBOARDING_URL}/party`) ||
				request.url.includes('/otp'))
		) {
			headers = headers.append('channel', 'WEB');
		}
		// Language
		if (!headers.has('language')) {
			const translateService = this.injector.get(TranslateService);
			headers = headers.append('language', translateService.currentLang);
		}
		if (this.token && !headers.has('accesstoken')) {
			headers = headers.append('accesstoken', this.token);
			
			if (this.userName && !headers.has('email')) {
				headers = headers.append('email', this.userName);
			}
		}

		return headers;
	}
}